<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="100" inline>
        <FormItem label="姓名" class="mb-2">
          <Input placeholder="请输入" v-model="table.search.PatientName"></Input>
        </FormItem>
        <FormItem label="身份证">
          <Input placeholder="请输入" v-model="table.search.IdCardNo"></Input>
        </FormItem>
        <FormItem label="医保号">
          <Input placeholder="请输入" v-model="table.search.MedicalNo"></Input>
        </FormItem>
        <FormItem label="门诊号">
          <Input placeholder="请输入" v-model="table.search.OutPatientNo"></Input>
        </FormItem>
        <FormItem label="住院号" class="mb-2">
          <Input placeholder="请输入" v-model="table.search.InPatientNo"></Input>
        </FormItem>
        <FormItem label="检查号" class="mb-2">
          <Input placeholder="请输入" v-model="table.search.AccessionNum"></Input>
        </FormItem>
        <FormItem label="病历号" class="mb-2">
          <Input placeholder="请输入" v-model="table.search.MedcaseNo"></Input>
        </FormItem>
        <FormItem label="医院编码" class="mb-2">
          <Select placeholder="请选择" clearable v-model="table.search.HospitalID" style="width:186px">
            <Option v-for="item in hospitalList" :value="item.organCode" :key="item.organID">{{item.organName}}({{item.organCode}})</Option>
          </Select>
        </FormItem>

        <!-- <FormItem label="患者电话">
          <Input class="w-250" v-model="table.search.PatientTell"></Input>
        </FormItem> -->
        <FormItem label="检查类型">
          <Select placeholder="请选择" v-model="table.search.Examtype" clearable>
            <Option
              v-for="(item, index) in ExamTypeSelect"
              :value="item.dictionaryValue"
              :key="index"
              >{{ item.dictionaryValue }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="开始时间">
          <Col span="12">
            <DatePicker
              type="date"
              v-model="table.search.StartTime"
              @on-change="table.search.StartTime = $event"
              placeholder="选择开始时间"
            ></DatePicker>
          </Col>
        </FormItem>
        <FormItem label="结束时间">
          <Col span="12">
            <DatePicker
              type="date"
              v-model="table.search.EndTime"
              @on-change="table.search.EndTime = $event"
              placeholder="选择结束时间"
            ></DatePicker>
          </Col>
        </FormItem>
        <Button class="ml-5" type="success" @click="search">查询</Button>
      </Form>
      <!--操作区域-->
      <div>
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--更新-->
    <Modal
      v-model="editModal"
      title="编辑版本"
      :footer-hide="true"
      
      :closable="false"
    >
      <reportedit
        v-if="editModal"
        @close="editModal = false"
        @loadData="search"
        :currentData="currentData"
      ></reportedit>
    </Modal>

    <!--详情-->
    <Modal
      v-model="detailModal"
      title="版本详情"
      :footer-hide="true"
      
      :closable="false"
    >
      <reportdetail
        v-if="detailModal"
        @close="detailModal = false"
        :currentData="currentData"
      ></reportdetail>
    </Modal>
    <!-- 匹配 -->
    <Modal
      v-model="matchingModal"
      title="匹配"
      :footer-hide="true"
      
      :closable="false"
      width="1000px"
    >
      <matchingList
        v-if="matchingModal"
        :value="matchingValue"
        @close="matchingModal = false"
      ></matchingList>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import reportdetail from "../report/detail.vue";
import matchingList from './components/matchingList.vue';

export default {
  components: { DataTable, reportdetail, matchingList },
  data: function () {
    return {
      currentData: {},
      detailModal: false,
      addModal: false,
      editModal: false,

      ExamTypeSelect: [],
      table: {
        columns: [
          //   {
          //     type: "selection",
          //     width: 60,
          //     align: "center",
          //   },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "检查编号", key: "accessionNum" },
          { title: "患者姓名", key: "patientName" },
          { title: "性别", key: "patientSex" },
          { title: "年龄", key: "patientAge" },
          {
            title: "检查日期",
            key: "examDate",
            render: (h, value) => {
              return h("div", this.formatTime(value.row.examDate));
            },
          },
          { title: "检查类型", key: "examType" },
          { title: "检查项目", key: "examItem" },
          { title: "报告医生", key: "reportDr" },
          { title: "审核医生", key: "verifyDr" },
          { title: "医院编码", key: "hospitalID" },

          {
            title: "报告日期",
            key: "reportDate",
            render: (h, value) => {
              return h("div", this.formatTime(value.row.examDate));
            },
          },

          {
            title: "操作",
            width: "150px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.matchingHandle(params.row);
                      },
                    },
                  },
                  "匹配"
                ),
              ]);
            },
          },
        ],
        apiUrl: "patient/GetReportPage",
        search: {
          PatientName: "",
          IdCardNo: "",
          MedicalNo: "",
          OutPatientNo: "",
          AccessionNum: "",
          InPatientNo: "",
          MedcaseNo: "",
          // PatientTell: "",
          Examtype: "",
          StartTime: '2022-03-10',
          EndTime: '2022-04-24',
          // StartTime: today,
          // EndTime: today,
        },
      },
      matchingModal: false
    };
  },

  created: function () {
    var _this = this;
    this.$common.getDictionaryByCode("JCLX").then((data) => {
      _this.ExamTypeSelect = data;
    });
  },
  activated(){
    this.search()
  },
  computed:{
    hospitalList(){
      return this.$store.state.hospitalList
    }
  },
  methods: {
    search: function () {
      this.$refs.dataTable.initload();
    },

    toDetail: function (data) {
      this.detailModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },

    toAdd: function () {
      this.$router.push({ path: "departmentAdd" });
    },
    matchingHandle(item){
      this.matchingValue={
        accessionNum:item.accessionNum,
        hospitalID:item.hospitalID
      }
      this.matchingModal=true
    },
    toEdit: function (data) {
      this.editModal = true;
      this.currentData = JSON.parse(JSON.stringify(data));
    },
    formatTime: function (value) {
      if (value) {
        return value.split(" ")[0];
      }
      return "";
    },

    addModelChange(data) {
      if (
        data &&
        document.getElementsByClassName("ivu-upload-list").length > 0
      ) {
        document.getElementsByClassName("ivu-upload-list")[0].innerHTML = "";
      }
    },
    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
<style scoped>
</style>